module.exports = __webpack_public_path__ + "static/media/three_sending_waves_header@2x.1f900ede.png";